import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Dropdown } from 'react-toolbox';
import TextArea from 'components/TextArea';
import S from '../../TemplateStyling.scss';
import parseMeasurement, { hasDecimalNotation } from './measurementParsing';

const singleOrDouble = [
  { value: 'Single', label: 'Single' },
  { value: 'Double', label: 'Double' },
];

function BarnDoorMeasures({ measures, onChange }) {
  const handleFieldChange = (idx, field, value) => {
    const updated = measures.map((m, i) =>
      (i === idx ? { ...m, [field]: value } : m),
    );
    onChange(updated);
  };

  const handleNestedChange = (idx, group, subfield, value) => {
    const updated = measures.map((m, i) => {
      if (i === idx) {
        return { ...m, [group]: { ...m[group], [subfield]: value } };
      }
      return m;
    });
    onChange(updated);
  };

  const addRow = () => {
    onChange([
      ...measures,
      {
        openingNumber: '',
        location: '',
        singleOrDouble: '',
        finishedOpening: { width: '', height: '' },
        hardwareTrack: { width: '', height: '' },
        handing: '',
        notes: '',
      },
    ]);
  };

  const removeRow = (idx) => {
    onChange(measures.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <h6>Barn Doors Measured</h6>
      {measures.map((measure, idx) => (
        <div key={measure.openingNumber || `barnDoor-${idx}`} style={{ border: '1px solid #eee', marginBottom: 10, padding: 10 }}>
          <div className={S.container}>
            <strong>ALL MEASURES MUST BE IN INCHES</strong>
            <strong>Opening #{idx + 1}</strong>
          </div>
          <Input label="Location" value={measure.location} onChange={v => handleFieldChange(idx, 'location', v)} />
          <Dropdown label="Single or Double" source={singleOrDouble} value={measure.singleOrDouble} onChange={v => handleFieldChange(idx, 'singleOrDouble', v)} />
          <strong>FINISHED OPENING</strong>
          <Input label="Width" hint="e.g. 34 1/2" value={measure.finishedOpening.width} onChange={v => handleNestedChange(idx, 'finishedOpening', 'width', v)} />
          <Input label="Height" hint="e.g. 34 1/2" value={measure.finishedOpening.height} onChange={v => handleNestedChange(idx, 'finishedOpening', 'height', v)} />
          <strong>HARDWARE TRACK</strong>
          <Input label="Width" hint="e.g. 34 1/2" value={measure.hardwareTrack.width} onChange={v => handleNestedChange(idx, 'hardwareTrack', 'width', v)} />
          <Input label="Height" hint="e.g. 34 1/2" value={measure.hardwareTrack.height} onChange={v => handleNestedChange(idx, 'hardwareTrack', 'height', v)} />
          <TextArea
            label="Notes"
            value={measure.notes || ''}
            onChange={e => handleFieldChange(idx, 'notes', e.target.value)}
          />
          <Button className={S.removeButton} label="Remove" onClick={() => removeRow(idx)} />
        </div>
      ))}
      <Button className={S.button} label="Add Barn Door" onClick={addRow} />
    </div>
  );
}

BarnDoorMeasures.propTypes = {
  measures: PropTypes.arrayOf(
    PropTypes.shape({
      openingNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      location: PropTypes.string,
      singleOrDouble: PropTypes.string,
      finishedOpening: PropTypes.shape({
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      hardwareTrack: PropTypes.shape({
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      handing: PropTypes.string,
      notes: PropTypes.string,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BarnDoorMeasures;

export function validateBarnDoorMeasures(measures) {
  const errors = {};
  measures.forEach((item, idx) => {
    if (item.finishedOpening) {
      ['width', 'height'].forEach((subfield) => {
        const value = item.finishedOpening[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx][`finishedOpening.${subfield}`] = [`finishedOpening.${subfield} must be a number or fraction.`];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx][`finishedOpening.${subfield}`] = [`finishedOpening.${subfield} must not use decimal notation; use a fraction instead (e.g. 34 1/2).`];
        }
      });
    }
    if (item.hardwareTrack) {
      ['width', 'height'].forEach((subfield) => {
        const value = item.hardwareTrack[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx][`hardwareTrack.${subfield}`] = [`hardwareTrack.${subfield} must be a number or fraction.`];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx][`hardwareTrack.${subfield}`] = [`hardwareTrack.${subfield} must not use decimal notation; use a fraction instead (e.g. 34 1/2).`];
        }
      });
    }
  });
  if (Object.keys(errors).length > 0) {
    errors.barnDoorMeasures = [
      'Please ensure all numeric fields are valid numbers.',
    ];
  }
  return errors;
}



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/measures/BarnDoorMeasures.jsx